
/**
 * 트윗 태그 정보
 */
export type GetExploreContent200PageAllOfThreeContentItemContentOneOfTags = {
  hashtags?: string[];
};
